// JOBE-0098.3: input row — Find icon + <input> + Ask-stub hint. The
// `␣ at column 1` stub renders an inline pill but does not flip the
// chrome to AI mode (Phase 3 ships Find only).

import { forwardRef } from 'react';

export const InputRow = forwardRef(function InputRow({
  value,
  onChange,
  onKeyDown,
  placeholder = 'Find or ask…',
}, ref) {
  const askStub = value.startsWith(' ');
  return (
    <div className="omni-pinput" data-mode="find">
      <span className="omni-pinput-icon" aria-hidden="true">⌕</span>
      <input
        ref={ref}
        type="text"
        className="omni-pinput-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck="false"
      />
      {askStub && (
        <span className="omni-ask-stub" role="status">
          Ask is coming in Phase 4
        </span>
      )}
    </div>
  );
});
